/* globals updateEventBind, addQueryParam */
(function () {
	'use strict';

	angular.module('app.dashboard')
		.controller('totalInventoryCtrl', totalInventoryCtrl);

	function totalInventoryCtrl($rootScope, $scope, $timeout, dashboardFilterInitializationService, $translate,
			weeklyLogItemService, pageTimingService,
			currencyFormatService, leanFilterService, weeklyDiffService) {
		$scope.filterService = dashboardFilterInitializationService;
		$scope.leanFilterService = leanFilterService;
		$scope.$parent.$parent.showViewReport = true;

		$scope.slideshowView = $rootScope.slideshowView;
		updateEventBind($scope, ['sideBarUpdate', 'adfFactoryChanged',
			'slideshowViewChanged', 'inventoryFilterChanged']);

		function getChart() {
			var columnDefinition = $scope.$parent.$parent.col;
			var curWidget = $scope.$parent.model;
			weeklyLogItemService.loadData()
				.then(
					function () {
						var results = weeklyLogItemService.getResultObj();
						$scope.chartData = results.data;
						angular.forEach(results.data, function (dp) {
							dp.wipValue = dp.totalOnHandValueManufactured - dp.finishedGoodValueManufactured;
						});
						$scope.currency = results.currency;
						$scope.empty = !$scope.chartData || !$scope.chartData.length;
						$scope.formattedBgNum = null;

						// calculate bgnum and delta
						if (!$scope.empty) {
							var lastPoint = $scope.chartData[$scope.chartData.length - 1];
							var lastValue = lastPoint.totalOnHandValue + lastPoint.totalOnHandValueManufactured;
							$scope.formattedBgNum = currencyFormatService.getWithParameters(
								lastValue, 0, $scope.currency);

							$scope.deltaValue = 0;
							$scope.formattedDelta = null;
							$scope.additionalDeltaText = null;
							if ($scope.chartData.length > 1) {
								var diff = weeklyDiffService.getDataPoints($scope.chartData);
								var previousValue = diff.previousDataPoint.totalOnHandValue + diff.previousDataPoint.totalOnHandValueManufactured;
								$scope.deltaValue = lastValue - previousValue;
								$scope.formattedDelta = currencyFormatService.getWithParameters(
									$scope.deltaValue, 0, $scope.currency);
								$scope.additionalDeltaText = weeklyDiffService.getAdditionalLabelText(diff.previousDataPoint);
								$scope.status = ($scope.deltaValue > 0) ? 'bad' : 'good';
							}
						}
						$scope.$broadcast('event:totalInventoryCtrl:getChart', null);
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
					},
					function (e) {
						$scope.empty = true;
						$scope.chartData = [];
						$scope.$broadcast('event:totalInventoryCtrl:getChart', null);
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
					}
				);
		}

		function loadData() {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView) {
					dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
				getChart();
			} else {
				$timeout(loadData, 100);
			}
		}

		loadData();
	}
})();
